import { Box, Spinner, Text } from '@chakra-ui/react';
import React from 'react';

interface LoadingWidgetProps {
    withImage: boolean;
    image?: string;
}

const LoadingWidget: React.FC<LoadingWidgetProps> = (props) => {
    return ( props.withImage ?
        <Box
            height="100vh"
            width="100vw"
            backgroundImage={props.image}
            backgroundSize="cover"
            backgroundPosition="center"
            display="flex"
            justifyContent="center"
            alignItems="center"
        >
            <Box
                bg="white"
                mt="89px"
                padding="5"
                borderRadius="md"
                boxShadow="lg"
                textAlign="center"
                width="2xl"
                height="80vh"
                display="flex"
                justifyContent="center"
                alignItems="center"
                flexDirection="column"
            >
                <Spinner m="13" size='xl' />
                <Text>Ładowanie...</Text>
            </Box>
        </Box> : 
            <>
                <Spinner m="13" size='xl' />
                <Text>Ładowanie...</Text>
            </>
            
    )
};

export default LoadingWidget;
